import React, { useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"

import toastHandler from "toastHandler"
import Toast from "components/Toast/Toast"

import { getToken } from "helpers/auth_helpers"

const Bundary = () => {
  const error = toastHandler(state => state.error)
  const cleanError = toastHandler(state => state.cleanError)
  const success = toastHandler(state => state.success)
  const cleanSuccess = toastHandler(state => state.cleanSuccess)
  const warnings = toastHandler(state => state.warnings)
  const cleanWarnings = toastHandler(state => state.cleanWarnings)

  const history = useHistory()
  const { pathname } = useLocation()

  useEffect(() => {
    const token = getToken()
    if (
      !token &&
      pathname !== "/iniciar-sesion" &&
      pathname !== "/cerrar-sesion" &&
      pathname !== "/estado-servicios"
    ) {
      history.push("/iniciar-sesion")
    }
  }, [localStorage.getItem("authUser"), pathname])

  if (error.hasError) {
    //if(!error.length){cleanError()}
    if (
      error.message == "Cannot read properties of undefined (reading 'length')"
    ) {
      cleanError()
    }
    return (
      <Toast
        open={error.message ? error.hasError : false}
        message={error.message}
        onClose={cleanError}
        severity="error"
      />
    )
  }

  if (success.hasSuccess) {
    return (
      <Toast
        open={success.hasSuccess}
        message={success.message}
        onClose={cleanSuccess}
        severity="success"
      />
    )
  }

  if (warnings.hasWarnings) {
    return (
      <Toast
        open={warnings.hasWarnings}
        message={warnings.message}
        onClose={cleanWarnings}
        severity="warning"
      />
    )
  }

  return <></>
}

export default Bundary
